export default "__VITE_ASSET__ZdHXneo4__"